import { InboxIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'

import { Spinner } from 'shared/atoms'
import { EmptyState } from '../EmptyState/EmptyState'

type EmptyTableProps = {
	isLoading?: boolean
	text?: string
}

export const EmptyTable = ({ isLoading, text }: EmptyTableProps) => {
	const { t } = useTranslation()

	if (isLoading) {
		return (
			<div className="flex justify-center py-12">
				<Spinner />
			</div>
		)
	}

	return <EmptyState icon={<InboxIcon />} text={text ?? t('No results')} />
}
